import React, { useContext, useState } from 'react';
import { isNull, isUndefined } from 'lodash';
import moment from 'moment';

import { resolveBasicCell } from 'components/pages/patient-source/shared/Worklist/ReactTableHoc/ReactTableHoc';
import { WorklistFinanceCompleteFilter } from 'components/pages/patient-source/shared/Worklist/WorklistTableHeaderFilter/WorklistFinanceCompleteFilter/WorklistFinanceCompleteFilter';

import Icon from '../../../../../../../common/general/Icon';
import { DD_SLASH_MMM_SLASH_YYYY } from '../../../../../../../constants/dateFormat';
import { scGray60, scPurple80 } from '../../../../../../../constants/systemColors';

export const FinanceCompleteFilterColumn = context => {
  return {
    id: 'financeCompleteDate',
    Header: <CustomFinanceCompleteSortAndFilterHeader title={'Finance Complete'} Context={context} />,
    accessor: 'financeCompleteDate',
    width: 200,
    Cell: ({ value }) => {
      return resolveBasicCell(
        !isNull(value) && !isUndefined(value)
          ? moment(value)
              .utc()
              .format(DD_SLASH_MMM_SLASH_YYYY)
          : ''
      );
    }
  };
};

export const CustomFinanceCompleteSortAndFilterHeader = ({ title, Context }) => {
  const [isFilterVisible, setFilterVisible] = useState(false);
  const ref = React.useRef();

  const { financeCompleteDate } = useContext(Context);

  return (
    <div className="rt-hoc-sort-header" ref={ref}>
      <WorklistFinanceCompleteFilter
        filterRef={ref}
        isFilterVisible={isFilterVisible}
        setFilterVisible={setFilterVisible}
        Context={useContext(Context)}
      />
      <Icon
        className={'filter-icon'}
        style={{
          color: financeCompleteDate ? scPurple80 : scGray60
        }}
        onClick={e => {
          e.stopPropagation();
          setFilterVisible(!isFilterVisible);
        }}
      >
        filter_alt
      </Icon>
      <div className="title">{title}</div>
      <div className="icons">
        <Icon>expand_less</Icon>
        <Icon>expand_more</Icon>
      </div>
    </div>
  );
};
